import { Pipe, PipeTransform } from '@angular/core';
import { CheckoutCommonUtil } from '../../../modules/checkout/utils/checkout-common-util';

@Pipe({
  name: 'frPostfix'
})
export class FrPostfixPipe implements PipeTransform {
  transform(translationKey: string) {
    const postfix = CheckoutCommonUtil.getFrTranslationPostfix();
    return `${translationKey}${postfix}`;
  }
}
